import axios from 'axios'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const BASE_COURSE_URL = `${BASE_URL}api/courses/`;
const BASE_PROVIDER_URL = `${BASE_URL}api/providers/`;

const CourseService = () => ({

    getAllCourses: async () => {
        const { data } = await axios.get(`${BASE_COURSE_URL}`);
        return data;
    },

    getCourses: async (page, pageSize, filters, token) => {

        const { data } = await axios.get(`${BASE_COURSE_URL}Paginated`, {
            params: {
                currentPage: page,
                pageSize,
                ...filters
            },
            cancelToken: token
        });
        return data;
    },

    getCourse: async (id) => {
        const { data } = await axios.get(`${BASE_COURSE_URL}${id}`);
        return data;
    },
    enableCourses: async (ids) => {
        const { data } = await axios.put(`${BASE_COURSE_URL}enable`, ids);
        return data;
    },
    enableCoursesBulk: async (filters) => {
        const { data } = await axios.put(`${BASE_COURSE_URL}enable/bulk`, filters);
        return data;
    },
    disableCourses: async (ids) => {
        const { data } = await axios.put(`${BASE_COURSE_URL}disable`, ids);
        return data;
    },
    disableCoursesBulk: async (filters) => {
        const { data } = await axios.put(`${BASE_COURSE_URL}disable/bulk`, filters);
        return data;
    },
    saveCourse: async (course) => {
        const { status } = await axios.put(`${BASE_COURSE_URL}${course.id}`, course);
        return status;
    },
    getClasses: async (id) => {
        const { data } = await axios.get(`${BASE_COURSE_URL}${id}/classes`);
        return data;
    },
    getClassGroups: async (id) => {
        const { data } = await axios.get(`${BASE_COURSE_URL}${id}/classGroups`);
        return data;
    },
    getConfig: async (id) => {
        const { data } = await axios.get(`${BASE_COURSE_URL}${id}/configurations`);
        return data;
    },
    editConfig: async (id, config) => {
        const { status } = await axios.put(`${BASE_COURSE_URL}${id}/configurations`, config);
        return status;
    },
    refreshCourse: async (courseId) => {
        const { status } = await axios.post(`${BASE_COURSE_URL}${courseId}/refresh?refreshCourse=true&refreshTeeTimes=true&logJob=true`);
        return status;
    },

    getPendingAllocationRounds: async (courseId, ruleId) => {
        const { data } = await axios.get(`${BASE_COURSE_URL}${courseId}/PendingAllocationRounds?ruleId=${ruleId}`);
        return data;

    },
    editPendingAllocationRounds: async (pendingAllocationRoundsDetails) => {
        const courseId = pendingAllocationRoundsDetails.courseId;
        const { status } = await axios.put(`${BASE_COURSE_URL}${courseId}/PendingAllocationRounds`, pendingAllocationRoundsDetails);
        return status;
    },

    getTeeTimeDetails: async (courseId, teetimeDate, rateTypeId) => {
        const requestURL = `${BASE_PROVIDER_URL}getTeeTimeDetails?courseId=${courseId}&teetimeDate=${teetimeDate}&rateTypeId=${rateTypeId}`;
        const { data } = await axios.get(requestURL);
        return data;
    },
    getCountriesList: async() => {
        const { data } = await axios.get(`${BASE_COURSE_URL}GetCountriesList`);
        return data;
    },
});

export default CourseService;